import React from "react";
import CasesTable from "@/components/CasesTable";
import { useL } from "@/context/I18nContext";

export default function AdminCases() {
  const L = useL();
  return (
    <div className="space-y-6">
      <h2 className="font-heading text-2xl font-medium text-white">{L("Pratiche", "Cases", "Fälle")}</h2>
      <CasesTable endpoint="/admin/cases" basePath="/admin/cases" />
    </div>
  );
}
